<template>
    <div class="brand-info">
        <div class="container-content grid-cols-12">
            <div class="col-span-7">
                <slot />
            </div>
            <div class="col-span-1"></div>
            <div class="col-span-1"></div>
            <div class="col-span-3">
                <div class="contact-info">
                    <div v-if="phone || email">
                        <p class="bold uppercase">{{ contactInfoLabel }}</p>
                        <p v-if="phone"><a class="dark" :href="`tel:${phoneHref || phone}`">{{ phone }}</a></p>
                        <p v-if="email"><a class="dark" :href="`mailto:${email}`">{{ email }}</a></p>
                    </div>
                    <div v-if="visibleSocials.length">
                        <p class="bold uppercase">{{ followLabel || `Follow ${brandName}` }}</p>
                        <p class="social-icons">
                            <a v-for="social in visibleSocials" :key="social.type" class="dark social-link"
                                :href="social.url" target="_blank" rel="noopener" :aria-label="social.label">
                                <component :is="social.component" width="36" height="36" />
                            </a>
                        </p>
                    </div>
                    <div v-if="amazonUrl">
                        <p class="bold uppercase">Buy Now On</p>
                        <a :href="amazonUrl" class="buy-amazon" target="_blank" rel="noopener">
                            <BuyAmazonIcon width="120" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SquareFacebookIcon from '@c/icons/SquareFacebook.vue';
import InstagramIcon from '@c/icons/Instagram.vue';
import BuyAmazonIcon from '@c/icons/BuyAmazon.vue';

const SOCIAL_TYPES = {
    facebook: { component: SquareFacebookIcon, label: 'Facebook' },
    instagram: { component: InstagramIcon, label: 'Instagram' },
};

export default {
    name: "BrandInfo",
    components: {
        SquareFacebookIcon,
        InstagramIcon,
        BuyAmazonIcon,
    },
    props: {
        brandName: { type: String, default: '' },
        phone: { type: String, default: '' },
        phoneHref: { type: String, default: '' },
        email: { type: String, default: '' },
        contactInfoLabel: { type: String, default: 'Contact Info' },
        followLabel: { type: String, default: '' },
        socials: {
            type: Array,
            default: () => [],
            validator: (items) => items.every((s) => s && s.url && SOCIAL_TYPES[s.type]),
        },
        amazonUrl: { type: String, default: '' },
    },
    computed: {
        visibleSocials() {
            return this.socials
                .filter((s) => s && s.url && SOCIAL_TYPES[s.type])
                .map((s) => ({
                    type: s.type,
                    url: s.url,
                    component: SOCIAL_TYPES[s.type].component,
                    label: SOCIAL_TYPES[s.type].label,
                }));
        },
    },
};
</script>

<style scoped lang="scss">
.brand-info {
    background: black;
    color: white;
    padding: 4rem 0;

}

.container-content {
    max-width: 1380px;
    margin: 0 auto;
    padding: 0 24px;

}

.contact-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 1rem;

}

.social-icons {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    line-height: 1;
}

.grid-cols-12 {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 1rem;
}

.col-span-7 {
    grid-column: span 7 / span 7;
}

.col-span-1 {
    grid-column: span 1 / span 1;
}

.col-span-3 {
    grid-column: span 3 / span 3;
}

.buy-amazon {
    display: inline-block;
    margin-top: 0.5rem;
}

@media (max-width: 768px) {
    .brand-info {
        p {
            font-size: 1rem;
        }
    }

    .grid-cols-12 {
        grid-template-columns: repeat(1, 1fr);
    }

    .col-span-7,
    .col-span-1,
    .col-span-3 {
        grid-column: span 1 / span 1;
    }

    .contact-info {
        gap: 1rem;
        justify-content: center;
        align-items: center;
        text-align: center;
    }

    .social-icons {
        justify-content: center;
    }
}
</style>